import { render } from "./UserCreation.vue?vue&type=template&id=b6126f46&scoped=true"
import script from "./UserCreation.vue?vue&type=script&lang=js"
export * from "./UserCreation.vue?vue&type=script&lang=js"

import "./UserCreation.vue?vue&type=style&index=0&id=b6126f46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6126f46"]])

export default __exports__